import { makeStyles } from '@mui/styles'

export default makeStyles({
  root: {
    overflow: 'hidden',
    width: '100%',
  },

  ul: {
    cursor: 'pointer',
    display: 'flex',
    margin: '0',
    padding: '0',
    willChange: 'transform',
  },
})
